import { UserViewModel } from "../../viewmodels/setup/users/UserViewModel";

import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

import { withRouter } from "../../shared/utility";
import MyAccountForm from "../../components/forms/my-account/MyAccountForm";
import MyPasswordForm from "../../components/forms/my-account/MyPasswordForm";
import DeveloperSettingsForm from "../../components/forms/my-account/DeveloperSettingsForm";

function MyAccount(props) {
  const {
    email,
    logout,
    name,
    updateAccountDetails,
    developerMode,
    setDeveloperMode,
  } = props;

  const { updateAccountPassword } = UserViewModel(logout);

  return (
    <div className="min-h-screen bg-surface px-4 py-5 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl space-y-6">
        <section className="rounded-2xl border border-border-subtle bg-card shadow-soft">
          <div className="border-b border-border-subtle px-6 py-5">
            <p className="text-[11px] font-semibold uppercase tracking-[0.16em] text-slate-500">
              WIP Sync / Account
            </p>
            <h1 className="mt-2 text-[1.65rem] font-semibold tracking-tight text-brand sm:text-3xl">
              My Account
            </h1>
            <p className="mt-2 max-w-2xl text-sm leading-6 text-slate-500">
              Manage your profile details and password. Changes apply to your
              login credentials across the platform.
            </p>
          </div>
        </section>

        <div className="grid gap-6 lg:grid-cols-2 lg:items-start">
          <MyAccountForm
            updateAccountDetails={updateAccountDetails}
            userDetails={{
              name: name,
              email: email,
            }}
          />

          <MyPasswordForm updateAccountPassword={updateAccountPassword} />

          <DeveloperSettingsForm
            developerMode={developerMode}
            setDeveloperMode={setDeveloperMode}
          />
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    name: state.auth.name,
    email: state.auth.email,
    developerMode: state.auth.developerMode,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    updateAccountDetails: (payload) =>
      dispatch(actions.updateAccountDetails(payload)),
    setDeveloperMode: (enabled) => dispatch(actions.setDeveloperMode(enabled)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MyAccount),
);
